<template>
  <div class="container schedule-container">
    <h1 class="title">{{ season.name }} Schedule Is Available!!</h1>
    <div class="schedule-button">
      <router-link :to="`/leagues/schedule/${season.id}/?search=league&league-view=matches`" type="button" class="button is-success is-inverted is-outlined is-rounded">See Schedule</router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ScheduleContainer',
  computed: {
    season() {
      let seasons = [this.$store.state.currentSeason, this.$store.state.upcomingSeason];
      let id = this.$route.params.seasonId;
      if (seasons[0] != null) {
        return seasons[0];
      }
      return seasons[1];
    },
  },
}
</script>